import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { changeAlertPopup, selectAlertPopup } from '../store/slice'

export const AlertPopup = () => {
  const dispatch = useDispatch()

  const { isShow, title, message, isI18n, translateProps } =
    useSelector(selectAlertPopup)

  const handleClose = () => {
    dispatch(
      changeAlertPopup({
        isShow: false,
        title: '',
        message: '',
        isI18n: true,
        translateProps: {},
      }),
    )
  }

  return (
    <PopupAction
      isShow={isShow}
      title={title}
      btnSubmit={{ label: 'screening.CLOSE', isI18n: true, event: handleClose }}
      handleClose={handleClose}
    >
      <Element className="textCenter pb2">
        <Icon
          className="icon-alert"
          style={{ color: '#E8B714', fontSize: 32 }}
        />
        <Element className="pt2" style={{ color: '#3A414B' }}>
          {isI18n ? <Translate value={message} {...translateProps} /> : message}
        </Element>
      </Element>
    </PopupAction>
  )
}
